import { Types } from 'src/generated/types';

const header = '';

const publics = ['/', `${header}/login`, `${header}/maintenance`];

const routes = {
  home: {
    root: `${header}/`,
  },
  auth: {
    login: `${header}/login`,
    logout: `${header}/logout`,
  },
  game: {
    lotto59: `${header}/game/lotto/59`,
    sport: `${header}/game/sport`,
    casino: {
      root: `${header}/game/casino`,
      // info: `${header}/game/casino/info`,
    },
    slot: {
      root: `${header}/game/slot`,
      play: `${header}/game/slot/play`,
    },
    fishing: {
      root: `${header}/game/fishing`,
      play: `${header}/game/fishing/play`,
    },

    lottery: {
      root: `${header}/game/lottery`,
      timeout: `${header}/game/lottery/timeout`,
      result: `${header}/game/lottery/result`,
      report: `${header}/game/lottery/report`,
      ticket: `${header}/game/lottery/ticket`,
      bet: (gameType?: Types.Lottery.GameType) =>
        `${header}/game/lottery/bet${gameType ? '/' + gameType.toLowerCase() : ''}`,
    },
  },
  user: {
    password: `${header}/user/password`,
  },
  report: {
    lotto59: `${header}/report/lotto/59`,
    lottery: `${header}/report/lottery`,
    sport: `${header}/report/sport`,
    casino: `${header}/report/casino`,
    fishing: `${header}/report/fishing`,
  },
  ticket: {
    lotto59: `${header}/ticket/lotto59`,
    lottery: `${header}/ticket/lottery`,
  },
  transaction: {
    deposit: `${header}/transaction/deposit`,
    withdraw: `${header}/transaction/withdraw`,
  },
};

const menus: Types.MenuSliderItem[] = [
  // {
  //   title: '1. ផ្សងសំណាង',
  //   icon: 'icon-park-solid:game-ps',
  //   children: [
  //     {
  //       title: '1 ឆ្នោតឡូតូសេដ្ឋីនាគ',
  //       icon: 'game-icons:crystal-ball',
  //       path: routes.game.lotto59,
  //     },
  //     {
  //       title: '1.2 កម្សាន្តបាល់ទាត់',
  //       icon: 'game-icons:soccer-ball',
  //       path: routes.game.football,
  //     },
  //     {
  //       title: '1.3 ហ្គេមកាស៊ីណូ',
  //       icon: 'mdi:casino',
  //       path: routes.game.casino.root,
  //     },
  //     {
  //       title: '1.4 បាញ់ត្រី',
  //       icon: 'game-icons:slot-machine',
  //       path: routes.game.fishing.root,
  //     },
  //     {
  //       title: '1.5 ហ្គេមស្លូត',
  //       icon: 'game-icons:slot-machine',
  //       path: routes.game.slot.root,
  //     },
  //   ],
  // },
  {
    title: '1 ឆ្នោតឡូតូសេដ្ឋីនាគ',
    icon: 'game-icons:crystal-ball',
    path: routes.game.lotto59,
  },
  {
    title: '1.2 កីឡា',
    icon: 'game-icons:soccer-ball',
    path: routes.game.sport,
  },
  {
    title: '1.3 កាស៊ីណូ',
    icon: 'mdi:casino',
    path: routes.game.casino.root,
  },
  {
    title: '1.4 បាញ់ត្រី',
    icon: 'game-icons:double-fish',
    path: routes.game.fishing.root,
  },
  {
    title: '2. ផ្ទៀងផ្ទាត់សំបុត្រ',
    icon: 'fluent:slide-search-32-filled',
    children: [
      {
        title: '2.1 មើលឆ្នោតឡូតូសេដ្ឋីនាគ',
        icon: 'mdi:paper-search',
        path: routes.ticket.lotto59,
      },
      // {
      //   title: '2.2 មើលឆ្នោតប្រាំសំណាង',
      //   icon: 'icon-park-solid:doc-search',
      //   path: routes.ticket.lottery,
      // },
    ],
  },
  {
    title: '3. ការដកប្រាក់',
    icon: 'vaadin:money-withdraw',
    children: [
      {
        title: '3.1 ប្រវត្តិដកប្រាក់',
        icon: 'vaadin:cash',
        path: routes.transaction.withdraw,
      },
    ],
  },
  {
    title: '4. ការដាក់ប្រាក់',
    icon: 'vaadin:money-deposit',
    children: [
      {
        title: '4.1 ប្រវត្តិដាក់ប្រាក់',
        icon: 'vaadin:cash',
        path: routes.transaction.deposit,
      },
    ],
  },
  {
    title: '5. របាយការណ៍',
    icon: 'fluent-mdl2:mobile-report',
    children: [
      {
        title: '5.1 របាយការណ៍ឆ្នោតឡូតូសេដ្ឋីនាគ',
        icon: 'mdi:report-finance',
        path: routes.report.lotto59,
      },
      {
        title: '5.2 របាយការណ៍កីឡា',
        icon: 'mdi:report-finance',
        path: routes.report.sport,
      },
      {
        title: '5.3 របាយការណ៍កាស៊ីណូ',
        icon: 'mdi:report-finance',
        path: routes.report.casino,
      },
      {
        title: '5.4 របាយការណ៍ត្រី',
        icon: 'mdi:report-finance',
        path: routes.report.fishing,
      },
    ],
  },
  {
    title: '6. ប្ដូរពាក្យសម្ងាត់',
    icon: 'mingcute:lock-fill',
    path: routes.user.password,
  },
  {
    title: '7. ចាកចេញ',
    icon: 'raphael:power',
    path: routes.auth.logout,
  },
  // {
  //   title: '7. ប្ដូរទម្រង់ចាស់',
  //   icon: 'ic:twotone-phonelink',
  //   path: '/'
  // }
];

const endpoints = {
  poll: '/api/poll',
  print: '/api/print',
  auth: {
    login: '/login',
    logout: '/logout',
    crsf: '/sanctum/csrf-cookie',
  },
  sport: {
    login: '/api/sport/login',
  },
  casino: {
    login: '/api/external/2/url',
  },
  slot: {
    list: '/api/external/3/list',
    url: '/api/external/3/url',
  },
  fishing: {
    dbUrl: '/api/external/4/url',
    boyaUrl: '/api/external/5/url',
    info: 'api/fishing/information',
    setToken: 'api/fishing/settoken',
    checkToken: 'api/fishing/token',
  },
  user: {
    detail: '/api/user',
    changePassword: '/api/user/change_password',
  },
  jackpot: {
    search: '/api/jackpot/search',
    winner: '/api/v1/jackpot/winner',
  },
  result: {
    home: '/api/result/history',
    recent: '/api/v1/result/recent',
    history: '/api/v1/result/history',
    playing: '/api/v1/result/playing',
    releasing: '/api/v1/result/releasing',
  },
  report: {
    bet: '/api/bet/report',
    sport: '/api/report/sport',
    sportTotal: '/api/report/sport/total',
    casino: '/api/report/casino',
    casinoTotal: '/api/report/casino/total',
    fishing: '/api/report/fishing',
    fishingTotal: '/api/report/fishing/total',
  },
  transaction: {
    list: '/api/transaction/list',
  },
  ticket: {
    list: '/api/v1/ticket/list',
    badge: '/api/v1/ticket/badge',
  },
  bet: {
    range: '/api/bet',
    jackpot: '/api/bet/jackpot',
  },

  lottery: {
    result: {
      time: '/api/lottery/result/time',
      timeout: '/api/lottery/result/timeout',
      root: (id: any) => `/api/lottery/result/${id}`,
    },
    ticket: {
      load: '/api/lottery/ticket/load',
      bet: '/api/lottery/ticket/bet',
      deleteTicket: '/api/lottery/ticket/delete',
      deleteTicketItem: '/api/lottery/ticket/delete/item',
      deletePayout: '/api/lottery/ticket/delete/payout/item',
      payout: '/api/lottery/ticket/payout',
      list: '/api/lottery/ticket/list',
      total: '/api/lottery/ticket/total',
      detail: '/api/lottery/ticket/items',
    },
  },
};

const Paths = {
  menus,
  routes,
  publics,
  endpoints,
  redirectLogin: routes.auth.login,
  redirectAfterLogin: routes.game.lotto59,
};

export default Paths;
